// extracted by mini-css-extract-plugin
export default {"title":"WiFunhLe1bH57gDYL0Zd","rtl":"pB0I9GmqTJXbMzFP3tdl"};